import { render, staticRenderFns } from "./TaxTable.vue?vue&type=template&id=906de016&scoped=true"
import script from "./TaxTable.vue?vue&type=script&lang=js"
export * from "./TaxTable.vue?vue&type=script&lang=js"
import style0 from "./TaxTable.vue?vue&type=style&index=0&id=906de016&prod&lang=css&scoped=true"
import style1 from "./TaxTable.vue?vue&type=style&index=1&id=906de016&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906de016",
  null
  
)

export default component.exports